export const translations = {
  fr: {
    nav: {
      home: "Accueil", residence: "La résidence", services: "Services et accompagnement",
      milieu: "Milieu de vie", admission: "Admission et disponibilités", gallery: "Galerie",
      faq: "FAQ", careers: "Carrières", contact: "Contact",
    },
    common: {
      call: "Appeler", planVisit: "Planifier une visite", directions: "Itinéraire",
      learnMore: "En savoir plus", send: "Envoyer", sending: "Envoi…", required: "requis",
      backHome: "Retour à l'accueil", loading: "Chargement…", tbc: "À confirmer",
      manageCookies: "Gérer mes témoins", skipToContent: "Aller au contenu principal",
      viewAll: "Tout voir", availability: "Disponibilité", price: "Tarif",
    },
    serviceStatus: {
      inclus: "Inclus", offert: "Offert", supplement: "En supplément",
      sur_evaluation: "Sur évaluation", non_offert: "Non offert",
    },
    home: {
      trustBar: ["Catégorie 4 (unités de soins)", "Présence 24/7", "Membre RQRA", "Laval · Auteuil"],
      presentationTitle: "Une présence bienveillante, un vrai chez-soi",
      presentationBody: "À la Résidence Doux Instants, nous offrons des soins personnalisés et un environnement chaleureux pour que chaque journée soit plus douce et paisible. Une résidence à taille humaine, à Laval.",
      audienceTitle: "À qui s'adresse la résidence",
      audience: [
        { t: "Aînés", d: "Un milieu de vie sécuritaire, chaleureux et respectueux de votre autonomie." },
        { t: "Familles", d: "La tranquillité d'esprit de savoir votre proche entre de bonnes mains." },
        { t: "Professionnels", d: "Des informations claires pour orienter et accompagner." },
        { t: "Chercheurs d'emploi", d: "Rejoignez une équipe humaine et passionnée." },
      ],
      servicesTitle: "Services et accompagnement",
      servicesIntro: "Des services pensés pour le confort, la sécurité et le bien-être.",
      milieuTitle: "Un milieu de vie chaleureux",
      milieuBody: "Des espaces lumineux, un jardin, une salle à manger conviviale et des activités douces au quotidien.",
      journeeTitle: "Une journée type",
      journee: [
        { h: "Matin", d: "Réveil en douceur, petit-déjeuner équilibré et soins personnalisés." },
        { h: "Avant-midi", d: "Activités douces, marche au jardin ou moments de détente." },
        { h: "Midi", d: "Repas chaud préparé sur place, partagé dans la salle à manger." },
        { h: "Après-midi", d: "Loisirs, visites des proches, sieste ou lecture." },
        { h: "Soir", d: "Souper convivial, activités calmes et accompagnement au coucher." },
      ],
      admissionTitle: "Le processus d'admission",
      admission: [
        { t: "Premier contact", d: "Appelez-nous ou remplissez le formulaire de visite." },
        { t: "Visite", d: "Découvrez la résidence et rencontrez l'équipe." },
        { t: "Évaluation des besoins", d: "Nous évaluons ensemble l'accompagnement requis." },
        { t: "Emménagement", d: "Nous facilitons une transition douce et rassurante." },
      ],
      galleryTitle: "Galerie",
      testimonialsTitle: "Mots de nos résidents",
      faqTitle: "Questions fréquentes",
      ctaTitle: "Prêt à visiter la résidence ?",
      ctaBody: "Planifiez une visite ou appelez-nous. Nous serons heureux de vous accueillir.",
    },
    forms: {
      name: "Nom complet", email: "Courriel", phone: "Téléphone", date: "Date souhaitée",
      subject: "Sujet", message: "Message", position: "Poste visé", portfolio: "Lien (LinkedIn, portfolio)",
      consent: "J'accepte que mes coordonnées soient utilisées pour répondre à ma demande.",
      consentCv: "J'accepte d'être contacté(e) au sujet de ma candidature (aucune donnée médicale demandée).",
      success: "Merci ! Votre demande a bien été envoyée.",
      error: "Une erreur est survenue. Veuillez réessayer.",
      noMedical: "Aucune donnée médicale, NAS ou date de naissance ne doit être transmise via ce formulaire.",
      visitTitle: "Planifier une visite", contactTitle: "Nous écrire", careersTitle: "Candidature spontanée",
    },
    footer: {
      tagline: "Résidence privée pour aînés · Laval",
      nav: "Navigation", legal: "Informations légales", contactUs: "Nous joindre",
      rights: "Tous droits réservés.",
      dataNotice: "Base de données de référence hébergée au Canada. Les notifications de formulaire sont acheminées vers une boîte Gmail (voir la politique de confidentialité).",
    },
    legal: {
      privacy: "Politique de confidentialité", cookies: "Politique sur les témoins",
      governance: "Gouvernance des renseignements", accessibility: "Déclaration d'accessibilité",
      terms: "Conditions d'utilisation",
    },
    consent: {
      title: "Votre vie privée",
      body: "Nous utilisons uniquement des témoins essentiels au fonctionnement du site. Certains contenus (carte interactive) ne se chargent qu'avec votre accord. Aucun outil d'analyse ni de marketing n'est utilisé.",
      refuse: "Refuser non essentiels", customize: "Personnaliser", acceptAll: "Tout accepter",
      save: "Enregistrer mes choix",
      necessary: "Strictement nécessaires", necessaryDesc: "Toujours actifs. Requis pour la sécurité et vos préférences.",
      functional: "Fonctionnels (carte / vidéo)", functionalDesc: "Désactivés par défaut. Activent la carte interactive et les vidéos externes.",
      alwaysOn: "Toujours actifs",
      centerTitle: "Centre de préférences des témoins",
    },
    map: {
      title: "Nous trouver", loadInteractive: "Charger la carte interactive",
      notice: "La carte interactive (OpenStreetMap) ne se charge qu'après votre accord.",
    },
    admin: {
      login: "Connexion administrateur", loginGoogle: "Se connecter avec Google",
      loginNotice: "Accès réservé au personnel autorisé.", dashboard: "Tableau de bord",
      logout: "Déconnexion", noAccess: "Votre compte n'a pas les droits d'administration.",
    },
    notFound: { title: "Page introuvable", body: "La page que vous cherchez n'existe pas ou a été déplacée." },
  },
  en: {
    nav: {
      home: "Home", residence: "The residence", services: "Services & care",
      milieu: "Living environment", admission: "Admission & availability", gallery: "Gallery",
      faq: "FAQ", careers: "Careers", contact: "Contact",
    },
    common: {
      call: "Call", planVisit: "Schedule a visit", directions: "Directions",
      learnMore: "Learn more", send: "Send", sending: "Sending…", required: "required",
      backHome: "Back to home", loading: "Loading…", tbc: "To be confirmed",
      manageCookies: "Manage cookies", skipToContent: "Skip to main content",
      viewAll: "View all", availability: "Availability", price: "Rate",
    },
    serviceStatus: {
      inclus: "Included", offert: "Offered", supplement: "Extra fee",
      sur_evaluation: "Upon assessment", non_offert: "Not offered",
    },
    home: {
      trustBar: ["Category 4 (care units)", "24/7 presence", "RQRA member", "Laval · Auteuil"],
      presentationTitle: "A caring presence, a true home",
      presentationBody: "At Résidence Doux Instants, we offer personalized care and a warm environment so every day is gentler and more peaceful. A human-scale residence in Laval.",
      audienceTitle: "Who the residence is for",
      audience: [
        { t: "Seniors", d: "A safe, warm living environment that respects your independence." },
        { t: "Families", d: "Peace of mind knowing your loved one is in good hands." },
        { t: "Professionals", d: "Clear information to guide and support." },
        { t: "Job seekers", d: "Join a caring, passionate team." },
      ],
      servicesTitle: "Services & care",
      servicesIntro: "Services designed for comfort, safety and well-being.",
      milieuTitle: "A warm living environment",
      milieuBody: "Bright spaces, a garden, a friendly dining room and gentle daily activities.",
      journeeTitle: "A typical day",
      journee: [
        { h: "Morning", d: "Gentle wake-up, balanced breakfast and personalized care." },
        { h: "Late morning", d: "Gentle activities, a walk in the garden or relaxation." },
        { h: "Noon", d: "Warm meal prepared on-site, shared in the dining room." },
        { h: "Afternoon", d: "Leisure, family visits, a nap or reading." },
        { h: "Evening", d: "Friendly dinner, calm activities and bedtime support." },
      ],
      admissionTitle: "The admission process",
      admission: [
        { t: "First contact", d: "Call us or fill out the visit form." },
        { t: "Visit", d: "Discover the residence and meet the team." },
        { t: "Needs assessment", d: "Together we assess the support required." },
        { t: "Move-in", d: "We ensure a smooth, reassuring transition." },
      ],
      galleryTitle: "Gallery",
      testimonialsTitle: "What our residents say",
      faqTitle: "Frequently asked questions",
      ctaTitle: "Ready to visit the residence?",
      ctaBody: "Schedule a visit or call us. We'd be delighted to welcome you.",
    },
    forms: {
      name: "Full name", email: "Email", phone: "Phone", date: "Preferred date",
      subject: "Subject", message: "Message", position: "Desired position", portfolio: "Link (LinkedIn, portfolio)",
      consent: "I agree that my contact details may be used to respond to my request.",
      consentCv: "I agree to be contacted about my application (no medical data requested).",
      success: "Thank you! Your request has been sent.",
      error: "An error occurred. Please try again.",
      noMedical: "No medical data, SIN or date of birth should be submitted through this form.",
      visitTitle: "Schedule a visit", contactTitle: "Write to us", careersTitle: "Spontaneous application",
    },
    footer: {
      tagline: "Private seniors' residence · Laval",
      nav: "Navigation", legal: "Legal information", contactUs: "Get in touch",
      rights: "All rights reserved.",
      dataNotice: "System-of-record database hosted in Canada. Form notifications are routed to a Gmail inbox (see the privacy policy).",
    },
    legal: {
      privacy: "Privacy policy", cookies: "Cookie policy",
      governance: "Information governance", accessibility: "Accessibility statement",
      terms: "Terms of use",
    },
    consent: {
      title: "Your privacy",
      body: "We only use cookies essential to the site's operation. Some content (interactive map) loads only with your consent. No analytics or marketing tools are used.",
      refuse: "Refuse non-essential", customize: "Customize", acceptAll: "Accept all",
      save: "Save my choices",
      necessary: "Strictly necessary", necessaryDesc: "Always on. Required for security and your preferences.",
      functional: "Functional (map / video)", functionalDesc: "Off by default. Enable the interactive map and external videos.",
      alwaysOn: "Always on",
      centerTitle: "Cookie preference center",
    },
    map: {
      title: "Find us", loadInteractive: "Load interactive map",
      notice: "The interactive map (OpenStreetMap) loads only after your consent.",
    },
    admin: {
      login: "Administrator login", loginGoogle: "Sign in with Google",
      loginNotice: "Access reserved for authorized staff.", dashboard: "Dashboard",
      logout: "Log out", noAccess: "Your account does not have admin rights.",
    },
    notFound: { title: "Page not found", body: "The page you are looking for doesn't exist or has moved." },
  },
};
